import React from "react";
import { ThemeContext } from "../../ContextProvider/ThemeContext";
import { FaTwitter, FaGithub, FaLinkedin } from "react-icons/fa"; // Import the required icons
import styles from "./Contact.module.css";

const Contact = () => {
  const { newTheme } = React.useContext(ThemeContext);
  return (
    <footer className={styles.footer} id="contact">
      <div className={styles.container}>
        <h1 style={{ color: `${newTheme.title}` }}>Get in Touch</h1>
        <p style={{ color: `${newTheme.para}` }} className={styles.paragraph}>
          I'm actively looking for any new opportunities in Full Stack Development.
        </p>
        <div style={{ color: `${newTheme.title}` }} className={styles.contactOptions}>
          <div className={styles.iconContainer}>
            <a
              href="https://x.com/krishnkumarjm"
              aria-label="Twitter"
              target="_blank"
              rel="noreferrer"
            >
              <FaTwitter size={30} />
            </a>
            <a
              href="https://github.com/kirankumarjmeshram"
              aria-label="GitHub"
              rel="noreferrer"
              target="_blank"
            >
              <FaGithub size={30} />
            </a>
            <a
              href="https://www.linkedin.com/in/kirankumar-j-meshram/"
              aria-label="LinkedIn"
              target="_blank"
              rel="noreferrer"
            >
              <FaLinkedin size={30} />
            </a>
          </div>
          <div className={styles.contactInfo}>
            <div className={styles.infoItem}>
              <i className="far fa-envelope"></i>
              <h3>kirankumar21895@gmail.com</h3>
            </div>
            <div className={styles.infoItem}>
              <i className="fas fa-phone-alt" />
              <h3>+91 8390114818</h3>
            </div>
          </div>
        </div>
      </div>
      <div style={{ background: `${newTheme.line}` }} className={styles.line} />
      <div style={{ color: `${newTheme.para}` }} className={styles.copyright}>
        Designed and built by Kirankumar, 2022 All rights reserved.
      </div>
    </footer>
  );
};

export default Contact;
